import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ProfileComponent} from './component/profile/profile.component';
import {InputTextModule} from 'primeng/components/inputtext/inputtext';
import {ButtonModule} from 'primeng/components/button/button';
import {ConfirmationService} from 'primeng/components/common/api';
import {GrowlModule} from 'primeng/components/growl/growl';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SharedModule} from 'primeng/components/common/shared';
import {TooltipModule} from 'primeng/components/tooltip/tooltip';
import {MessagesModule} from 'primeng/components/messages/messages';
import {DropdownModule} from 'primeng/components/dropdown/dropdown';
import {TriStateCheckboxModule} from 'primeng/components/tristatecheckbox/tristatecheckbox';
import {PanelModule} from 'primeng/components/panel/panel';
import {ConfirmDialogModule} from 'primeng/components/confirmdialog/confirmdialog';
import {FieldsetModule} from 'primeng/components/fieldset/fieldset';
import {MultiSelectModule} from 'primeng/components/multiselect/multiselect';
import {DataTableModule} from 'primeng/components/datatable/datatable';
import {PickListModule} from 'primeng/components/picklist/picklist';
import {CurriculumComponent} from './component/curriculum/curriculum.component';
import {CalendarModule} from 'primeng/components/calendar/calendar';
import {InputSwitchModule} from 'primeng/components/inputswitch/inputswitch';
import {ProfileService} from './service/profile.service';
import {CurriculumVitaeService} from './service/curriculum-vitae.service';
import {AutoCompleteModule} from 'primeng/components/autocomplete/autocomplete';
import {InputTextareaModule} from 'primeng/components/inputtextarea/inputtextarea';
import {FlexLayoutModule} from '@angular/flex-layout';
import {ValidationMessagesModule} from '../core/validation-messages/validation-messages.module';
import {NgxCroppieModule} from 'ngx-croppie';
import { MatButtonModule, MatDialogModule, MatIconModule } from '@angular/material';
import { PhotoCropDialogComponent } from './component/profile/photo-crop-dialog/photo-crop-dialog.component'
import { ProfileStoreService } from './service/profile-store.service';


@NgModule({
    imports: [
        GrowlModule,
        RouterModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ValidationMessagesModule,
        PickListModule,
        InputTextModule,
        ButtonModule,
        DataTableModule,
        SharedModule,
        TooltipModule,
        MessagesModule,
        MultiSelectModule,
        DropdownModule,
        TriStateCheckboxModule,
        PanelModule,
        ConfirmDialogModule,
        FieldsetModule,
        CalendarModule,
        InputSwitchModule,
        AutoCompleteModule,
        InputTextareaModule,
        FlexLayoutModule,
        MatButtonModule,
        MatDialogModule,
        NgxCroppieModule,
        MatIconModule,
    ],
    declarations: [ProfileComponent, CurriculumComponent, PhotoCropDialogComponent],
    providers: [ConfirmationService, CurriculumVitaeService, ProfileStoreService],
    entryComponents: [PhotoCropDialogComponent]
})
export class ProfileModule {
}



// WEBPACK FOOTER //
// ./src/app/profile/profile.module.ts